module.exports = __webpack_public_path__ + "static/media/save.def1aee0.svg";